import { render, staticRenderFns } from "./MediatypeColumnModal.vue?vue&type=template&id=53aa20ec&scoped=true"
import script from "./MediatypeColumnModal.vue?vue&type=script&lang=js"
export * from "./MediatypeColumnModal.vue?vue&type=script&lang=js"
import style0 from "./MediatypeColumnModal.vue?vue&type=style&index=0&id=53aa20ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa20ec",
  null
  
)

export default component.exports